import { AtlasSvgIconDescription } from "@asfinag/atlas";

export const SVG_ICONS: AtlasSvgIconDescription[] = [
	{ name: "add", path: "assets/icons/add.svg" },
	{ name: "arrow_drop_down", path: "assets/icons/arrow_drop_down.svg" },
	{ name: "autorenew", path: "assets/icons/autorenew.svg" },
	{ name: "calendar_today", path: "assets/icons/calendar_today.svg" },
	{ name: "chevron_right", path: "assets/icons/chevron_right.svg" },
	{ name: "close", path: "assets/icons/close.svg" },
	{ name: "date_range", path: "assets/icons/date_range.svg" },
	{ name: "done", path: "assets/icons/done.svg" },
	{ name: "list", path: "assets/icons/list.svg" },
	{ name: "map", path: "assets/icons/map.svg" },
	{ name: "my_location", path: "assets/icons/my_location.svg" },
	{ name: "notifications", path: "assets/icons/notifications.svg" },
	{ name: "open_with", path: "assets/icons/open_with.svg" },
	{ name: "person", path: "assets/icons/person.svg" },
	{ name: "play_arrow", path: "assets/icons/play_arrow.svg" },
	{ name: "play_circle", path: "assets/icons/play_circle.svg" },
	{ name: "remove", path: "assets/icons/remove.svg" },
	{ name: "save", path: "assets/icons/save.svg" },
	{ name: "stop", path: "assets/icons/stop.svg" },
	{ name: "warning", path: "assets/icons/warning.svg" },
];
